import React, { useEffect, useState } from 'react';
import { fetchCollegesOrDepartments } from '../api';
import { FaSync } from 'react-icons/fa';
import './Header.css'; // Placeholder

const Header = ({
  selectedCollege,
  onCollegeChange,
  selectedDepartment,
  onDepartmentChange,
  onRefresh,
  isRefreshing,
  refreshCooldown,
  autoRefreshTimer,
  showControls = true,
  title, // Old title prop for MainPage
  mainTitle, // New prop for NoticePage
  subTitle,  // New prop for NoticePage
  lastRefreshTime
}) => {
  const mainPageUrl = window.location.hostname === 'localhost' ? '/' : 'https://my-skku.xyz';

  const [colleges, setColleges] = useState([]);
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    if (!showControls) return; // Don't fetch if controls are hidden

    const loadOptions = async () => {
      try {
        const data = await fetchCollegesOrDepartments();
        setColleges(data.filter(item => !item.isDepartment));
        setDepartments(data.filter(item => item.isDepartment));
      } catch (error) {
        console.error("Failed to load colleges/departments", error);
      }
    };
    loadOptions();
  }, [showControls]);

  const formatTime = (ms) => {
    const totalSeconds = Math.ceil(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const formatLastRefresh = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleTimeString('ko-KR', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
  };

  const displayTitle = (mainTitle && subTitle) ? (
    <>{mainTitle}&nbsp;<span className="subtitle-notice">{subTitle}</span></>
  ) : (
    title // Fallback for MainPage or if only title is provided
  );

  return (
    <header className="app-header">
      <div className="header-left">
                    <h1 className="app-title">
                      <a href={mainPageUrl}>
                        {mainTitle ? mainTitle : displayTitle} {/* Use mainTitle if present, else original displayTitle (for 'my SKKU') */}
                      </a>
                      {mainTitle && subTitle && ( // If it's the Notice page title (mainTitle and subTitle exist)
                        <span className="subtitle-notice">{subTitle}</span>
                      )}
                    </h1>        {showControls && (
          <div className="selector-group">
            <select 
              value={selectedCollege ? JSON.stringify(selectedCollege) : ""} 
              onChange={(e) => onCollegeChange(e.target.value ? JSON.parse(e.target.value) : null)}
              className="header-select"
            >
              <option value="">단과대 선택</option>
              {colleges.map(college => (
                <option key={college.id} value={JSON.stringify(college)}>
                  {college.name}
                </option>
              ))}
            </select>

            <select 
              value={selectedDepartment ? JSON.stringify(selectedDepartment) : ""} 
              onChange={(e) => onDepartmentChange(e.target.value ? JSON.parse(e.target.value) : null)}
              className="header-select"
            >
              <option value="">학과 선택</option>
              {departments.map(dept => (
                <option key={dept.id} value={JSON.stringify(dept)}>
                  {dept.name}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
      
      {showControls && (
        <div className="header-right">
          <div className="refresh-container">
            <span className="last-update-time">
              {lastRefreshTime && `최근 업데이트: ${formatLastRefresh(lastRefreshTime)}`}
            </span>
            <div className="timer-wrapper">
              <span className="refresh-label">자동 갱신 <span className="live-indicator"></span></span>
              <span className="refresh-timer">{formatTime(autoRefreshTimer)}</span>
            </div>
            <button 
              className={`refresh-button ${isRefreshing || refreshCooldown > 0 ? 'disabled' : ''}`} 
              onClick={onRefresh}
              disabled={isRefreshing || refreshCooldown > 0}
            >
              <FaSync className={isRefreshing ? 'spin' : ''} />
              {refreshCooldown > 0 ? ` ${Math.ceil(refreshCooldown / 1000)}s` : ' 새로고침'}
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;